// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea_textarea__MKshH","label":"Textarea_label__vcDLr"};